<template>
  <div class="mt-5">
    <button class="btn" @click="appPresentOverlay(value.btnAction)">
      <i>
        <svg
          width="20px"
          height="20px"
          viewBox="0 0 20 20"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g
            id="Page-1"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <path
              d="M10,20 C4.4771525,20 0,15.5228475 0,10 C0,4.4771525 4.4771525,0 10,0 C15.5228475,0 20,4.4771525 20,10 C20,15.5228475 15.5228475,20 10,20 Z M10,18 C14.418278,18 18,14.418278 18,10 C18,5.581722 14.418278,2 10,2 C5.581722,2 2,5.581722 2,10 C2,14.418278 5.581722,18 10,18 Z M10,9 C10.5522847,9 11,9.44771525 11,10 L11,14 C11,14.5522847 10.5522847,15 10,15 C9.44771525,15 9,14.5522847 9,14 L9,10 C9,9.44771525 9.44771525,9 10,9 Z M10,5 C10.5522847,5 11,5.44771525 11,6 C11,6.55228475 10.5522847,7 10,7 C9.44771525,7 9,6.55228475 9,6 C9,5.44771525 9.44771525,5 10,5 Z"
              id="Combined-Shape"
              fill="#668C9F"
            ></path>
          </g>
        </svg>
      </i>
      {{ value.btnTxt }}
    </button>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  export default {
    props: ['value', 'id', 'config'],
    data() {
      return {
        showInput: false,
      };
    },
    methods: {
      ...mapActions(['appPresentOverlay']),
    },
  };
</script>
<style lang="scss" scoped>
  i {
    position: absolute;
    left: 0;
    top: 3px;
  }
  .btn {
    position: relative;
    padding-left: 32px;
    font-size: 12px;
    letter-spacing: 0.08rem;
  }
</style>
